module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "post-main"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.title),
      expression: "title"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "标题（必填）"
    },
    domProps: {
      "value": (_vm.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.title = $event.target.value
      }
    }
  }), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content),
      expression: "content"
    }],
    staticClass: "textarea",
    attrs: {
      "placeholder": "说说我的看法吧",
      "rows": "10"
    },
    domProps: {
      "value": (_vm.content)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.content = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "toolbar card"
  }, [_c('header', {
    staticClass: "columns is-mobile"
  }, [_c('div', {
    staticClass: "column is-2"
  }, [_c('i', {
    staticClass: "iconfont icon icon-smile",
    on: {
      "click": function($event) {
        _vm.expandSmileBox()
      }
    }
  })]), _vm._v(" "), (_vm.attachment) ? _c('div', {
    staticClass: "column is-2 file-field"
  }, [_c('i', {
    staticClass: "iconfont icon icon-img"
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "accept": "image/*",
      "name": "attachment",
      "id": "attachment"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "column is-2"
  }, [_c('i', {
    staticClass: "iconfont icon icon-at",
    on: {
      "click": function($event) {
        _vm.insertMention()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column is-2 post-button",
    class: _vm.attachment ? 'is-offset-5' : 'is-offset-7'
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.post()
      }
    }
  }, [_vm._v("发表")])])])]), _vm._v(" "), (_vm.showSmileBox) ? _c('section', {
    staticClass: "smile-box"
  }, [_c('div', {
    staticClass: "tabs"
  }, [_c('ul', [_c('li', {
    class: _vm.activeSmileSuite == 'em' ? 'is-active' : '',
    on: {
      "click": function($event) {
        _vm.clickSmileSuite('em')
      }
    }
  }, [_c('a', [_vm._v("经典")])]), _vm._v(" "), _c('li', {
    class: _vm.activeSmileSuite == 'ema' ? 'is-active' : '',
    on: {
      "click": function($event) {
        _vm.clickSmileSuite('ema')
      }
    }
  }, [_c('a', [_vm._v("悠嘻猴")])]), _vm._v(" "), _c('li', {
    class: _vm.activeSmileSuite == 'emb' ? 'is-active' : '',
    on: {
      "click": function($event) {
        _vm.clickSmileSuite('emb')
      }
    }
  }, [_c('a', [_vm._v("兔斯基")])]), _vm._v(" "), _c('li', {
    class: _vm.activeSmileSuite == 'emc' ? 'is-active' : '',
    on: {
      "click": function($event) {
        _vm.clickSmileSuite('emc')
      }
    }
  }, [_c('a', [_vm._v("洋葱头")])])])]), _vm._v(" "), _vm._l((_vm.smiles), function(meta) {
    return (meta.name == _vm.activeSmileSuite) ? _c('div', {
      key: meta.name,
      staticClass: "smile-images"
    }, _vm._l((meta.serials), function(i) {
      return _c('figure', {
        key: i,
        class: ("image is-" + (meta.size)),
        on: {
          "click": function($event) {
            _vm.insertSmile(meta.name, i)
          }
        }
      }, [_c('img', {
        attrs: {
          "alt": "",
          "src": ("//bbs.byr.cn/img/ubb/" + (meta.name) + "/" + i + ".gif")
        }
      })])
    })) : _vm._e()
  })], 2) : _vm._e(), _vm._v(" "), (_vm.attachment && _vm.showUploadBox) ? _c('section', {
    staticClass: "upload-box"
  }, [_vm._l((_vm.uploadItems), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "upload-item"
    }, [_c('span', {
      style: ('background-image: url(' + item + ')')
    }), _vm._v(" "), _c('div', {
      staticClass: "close-btn",
      on: {
        "click": function($event) {
          _vm.removeImage(index)
        }
      }
    }, [_c('i', {
      staticClass: "icon iconfont icon-wrong"
    })])])
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showUploadLoader),
      expression: "showUploadLoader"
    }],
    staticClass: "upload-item"
  }, [_vm._m(0)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.uploadItems.length),
      expression: "uploadItems.length"
    }],
    staticClass: "upload-item new-upload"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "accept": "image/*",
      "name": "attachment",
      "id": "attachment2"
    }
  })])], 2) : _vm._e(), _vm._v(" "), _vm._m(2), _vm._v(" "), (_vm.pageLoading) ? _c('div', {
    staticClass: "loading-section"
  }, [_vm._m(3)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ball-pulse"
  }, [_c('div'), _c('div'), _c('div')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "new-upload-icon"
  }, [_c('i', {
    staticClass: "icon iconfont icon-add"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tool-tip content"
  }, [_c('blockquote', [_vm._v("未认证手机号的用户请使用电脑版在控制面板处进行手机号验证")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading ball-pulse"
  }, [_c('div'), _c('div'), _c('div')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-307f4852","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Post.vue
// module id = 238
// module chunks = 1